<template>
  <div>
    <div
      :class="active == item ? 'color_item active' : 'color_item'"
      v-for="item in colorList"
      :key="item"
      @click="handleSetColor(item)"
    >
      <span :style="'background-color:' + item"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Colors',
  props: ['active'],
  data() {
    return {
      colorList: [
        'rgb(250, 250, 250)',
        'rgb(255, 255, 0)',
        'rgb(0, 85, 255)',
        'rgb(255, 0, 140)',
        'rgb(0, 255, 100)',
        'rgb(200, 0, 255)',
        'rgb(0, 255, 255)',
        'rgb(255, 0, 0)',
        'rgb(0, 128, 255)',
      ],
    };
  },
  mounted() {
    // if (!this.active) {
    //   this.active = this.colorList[0];
    // }
  },
  methods: {
    handleSetColor(color) {
      this.$emit('change', color);
      // const activeObject = this.canvas.getActiveObject();
      // console.log(activeObject.type);
      // if (activeObject == 'undefined') return;
      // if (activeObject.type == 'image') {
      //   // console.log(this.canvas.getActiveObject());
      //   this.changeImageColorFilter(activeObject, color);
      // } else if (activeObject.type == 'textbox') {
      //   this.changeTextColorFilter(activeObject, color);
      // }
    },
  },
};
</script>

<style lang="less">
.color_item {
  width: 30px;
  height: 30px;
  display: inline-block;
  margin-right: 10px;
  border: 2px solid #eaeaea;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  span {
    display: block;
    width: 100%;
    height: 100%;
  }
  &.active {
    border: 2px solid #000;
  }
}
</style>
